// Local translations
export const T = {
  en_GB: {
    title: "Preview",
    description: "How this looks on a flow page",
    halfWidth: "In a column",
    fullWidth: "Full width",
    light: "Light",
    dark: "Dark",
  },
  nb_NO: {
    title: "Forhåndsvisning",
    description: "Slik ser den ut på en flyt-side",
    halfWidth: "I en kolonne",
    fullWidth: "Full bredde",
    light: "Lys",
    dark: "Mørk",
  },
} as const;
